import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const RemoveGlyph = /*#__PURE__*/createElement("g", {
  id: "remove"
}, /*#__PURE__*/createElement("path", {
  d: "M67.5,40.5h-51c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h51c0.8,0,1.5-0.7,1.5-1.5S68.3,40.5,67.5,40.5z"
}));
const Remove = createSvg({
  name: 'remove',
  path: RemoveGlyph
});

export default Remove;
export { RemoveGlyph };
